import { useState } from "react";

import Header from "@/components/Header";
import ShowcaseSection from "@/components/ShowcaseSection";
import DemoGalleryModal from "@/components/DemoGalleryModal";
import Footer from "@/components/Footer";

export default function AccommodationPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <>
      <DemoGalleryModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />

      <main className="rz-page">
        <Header isSubpage />
        <ShowcaseSection onOpenDemo={() => setIsDemoModalOpen(true)} />
        <Footer />
      </main>
    </>
  );
}
